"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeHelpers = void 0;
class KnowledgeHelpers {
    static extractKnowledgeIds(activeSectionData) {
        const selectedKnowledge = [];
        const fullKnowledgeIds = [];
        if (!(activeSectionData === null || activeSectionData === void 0 ? void 0 : activeSectionData.knowledgeEntries)) {
            return { selectedKnowledge, fullKnowledgeIds };
        }
        activeSectionData.knowledgeEntries.forEach(sectionKnowledge => {
            var _a;
            if (sectionKnowledge.knowledge) {
                const knowledgeId = (_a = sectionKnowledge.knowledge.id) === null || _a === void 0 ? void 0 : _a.toString();
                if (knowledgeId) {
                    selectedKnowledge.push(knowledgeId);
                    if (sectionKnowledge.knowledge.content ||
                        sectionKnowledge.knowledge.description ||
                        sectionKnowledge.knowledge.file) {
                        fullKnowledgeIds.push(knowledgeId);
                    }
                }
            }
        });
        return { selectedKnowledge, fullKnowledgeIds };
    }
}
exports.KnowledgeHelpers = KnowledgeHelpers;
